import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Education from '../components/Education';
import Certificates from '../components/Certificates';
import { CONTACT_INFO } from '../data';
import { FaLink, FaLinkedin, FaGithubSquare } from 'react-icons/fa';
import { ImMail2, ImPhone } from 'react-icons/im';
import usePageTitle from '../hooks/usePageTitle';

import("../styles/resume.scss");

function Professional() {
  usePageTitle(CONTACT_INFO.name + " - " + CONTACT_INFO.title);
  
  return (
    <section>
        <div id="Intro">
          <h1>{CONTACT_INFO.name}<div>{CONTACT_INFO.title}</div></h1>
          <div>
            <ul>
              <li><ImMail2 title="Email" />{CONTACT_INFO.email}</li>
              <li>
                <a href={CONTACT_INFO.linkedIn.url}><FaLinkedin title="LinkedIn Logo" /></a>
                <a href={CONTACT_INFO.linkedIn.url}>{CONTACT_INFO.linkedIn.text}</a>
              </li>
              <li>
                <a href={CONTACT_INFO.gitHub.url}><FaGithubSquare title="GitHub" /></a>
                <a href={CONTACT_INFO.gitHub.url}>{CONTACT_INFO.gitHub.text}</a>
                <a href={CONTACT_INFO.siteName.url}><FaLink title="Donchano" /></a>
                <a href={CONTACT_INFO.siteName.url}>{CONTACT_INFO.siteName.text}</a>
              </li>
              <li><ImPhone title="Phone" />{CONTACT_INFO.phone}</li>
            </ul>
          </div>
      </div>
      
      <div className="main">
        <About />
        <Experience />
        <Skills />
        <Certificates />
        <Education />
      </div>
    </section>
  );
}

export default Professional;
